/* eslint-disable no-param-reassign */
import ROUTE_DATA from '@rover/constants/src/platform/route-data.json';

export const INTERNAL_LINKING_REGEX = new RegExp(`^(${ROUTE_DATA.internal_linking.join('|')})`);
export const SERVICE_LANDING_REGEX = new RegExp(`^(${ROUTE_DATA.service_landing.join('|')})`);
export const STATIC_WORDPRESS_PAGES = new Set(ROUTE_DATA.static_wordpress || []);

export const SERVICE_LANDING_REGEX_FOR_REACT_ROUTER = ROUTE_DATA.service_landing.map((regex) =>
  regex.replace('^', '').replace('/$', '/')
);

export const INTERNAL_LINKING_REGEX_FOR_REACT_ROUTER = ROUTE_DATA.internal_linking.map((regex) =>
  regex.replace('(/.*)?$', '/*')
);

export default ROUTE_DATA;
